/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _module = __webpack_require__(1);
	
	var breakPoint = 768;
	var resizeFlag = false;
	var windowWidth = window.innerWidth;
	var windowHeight = window.innerHeight;
	var windowWidthJQ = $(window).width();
	
	var setMainSlider = function setMainSlider() {
	  var sliderImageWidth = void 0;
	  var sliderExtraWidth = void 0;
	  var sliderObject = void 0;
	  if (windowWidthJQ > breakPoint) {
	    sliderImageWidth = 532;
	    sliderExtraWidth = 0;
	  } else {
	    sliderImageWidth = windowWidthJQ * 0.5;
	    sliderExtraWidth = 0;
	  }
	  sliderObject = $('.servicesMainSlider').slick({
	    speed: 425,
	    autoplay: true,
	    autoplaySpeed: 3250,
	    infinite: true,
	    dots: true,
	    arrows: false,
	    slidesToShow: 1,
	    centerMode: true,
	    centerPadding: sliderExtraWidth + 'px',
	    cssEase: 'cubic-bezier(.5,.15,.25,1)'
	  });
	  $(window).on('load', function () {
	    $('.servicesMainSlider').addClass('is-Loaded');
	  });
	  //  $(window).on('resize' , function() {
	  //   let resizeWidhJQ = $(window).width();
	  //   let sliderResizeWidth;
	  //   let sliderExtraResizeWidth;
	  //   if (resizeWidhJQ > breakPoint) {
	  //     sliderResizeWidth      = 532;
	  //     sliderExtraResizeWidth = 0;
	  //   } else {
	  //     sliderResizeWidth      = resizeWidhJQ * 0.5;
	  //     sliderExtraResizeWidth = 0;
	  //   }
	  //   sliderObject[0].slick.options.centerPadding = sliderExtraResizeWidth + 'px';
	  // });
	};
	setMainSlider();
	
	var setSubSlider = function setSubSlider() {
	  var sliderImageWidth = void 0;
	  var sliderExtraWidth = void 0;
	  var sliderObject = void 0;
	  if (windowWidthJQ > breakPoint) {
	    sliderImageWidth = 532;
	    sliderExtraWidth = 0;
	  } else {
	    sliderImageWidth = windowWidthJQ * 0.5;
	    sliderExtraWidth = 0;
	  }
	  sliderObject = $('.servicesSubSlider').slick({
	    speed: 425,
	    autoplay: true,
	    autoplaySpeed: 3250,
	    infinite: true,
	    dots: true,
	    arrows: false,
	    slidesToShow: 1,
	    centerMode: true,
	    centerPadding: sliderExtraWidth + 'px',
	    cssEase: 'cubic-bezier(.5,.15,.25,1)'
	  });
	  $(window).on('load', function () {
	    $('.servicesSubSlider').addClass('is-Loaded');
	  });
	  //  $(window).on('resize' , function() {
	  //   let resizeWidhJQ = $(window).width();
	  //   let sliderResizeWidth;
	  //   let sliderExtraResizeWidth;
	  //   if (resizeWidhJQ > breakPoint) {
	  //     sliderResizeWidth      = 532;
	  //     sliderExtraResizeWidth = 0;
	  //   } else {
	  //     sliderResizeWidth      = resizeWidhJQ * 0.5;
	  //     sliderExtraResizeWidth = 0;
	  //   }
	  //   sliderObject[0].slick.options.centerPadding = sliderExtraResizeWidth + 'px';
	  // });
	};
	setSubSlider();
	
	(0, _module.loadFonts)();
	
	(0, _module.detectionScroll)();
	
	(0, _module.switchHeader)();
	
	(0, _module.switchServices)();
	
	(0, _module.anchorScroll)();

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var breakPoint = 768;
	var resizeFlag = false;
	var windowWidth = window.innerWidth;
	var windowHeight = window.innerHeight;
	var windowWidthJQ = $(window).width();
	
	// -------------------------------------------------------------------
	// loadFonts
	// →
	// -------------------------------------------------------------------
	var loadFonts = function loadFonts() {
	  var $targetLink = $('a:not([href^="#"]):not([target]):not([href^="mailto:contact@vistec.co.jp"]):not([href^="tel:"])');
	  var $targetLoad = $('#load');
	  var $targetContainer = $('#container');
	  $targetLink.on('click', function (e) {
	    e.preventDefault();
	    var targetUrl = $(this).attr('href');
	    if (targetUrl !== '') {
	      $targetLoad.removeClass('is-Loaded');
	      $targetLoad.addClass('is-Loading');
	      setTimeout(function () {
	        window.location = targetUrl;
	      }, 650);
	    }
	    return false;
	  });
	  window.addEventListener('load', function () {
	    $targetLoad.removeClass('is-Loading');
	    $targetLoad.addClass('is-Loaded');
	    setTimeout(function () {
	      $targetContainer.removeClass('is-Loading');
	      $targetContainer.addClass('is-Loaded');
	    }, 50);
	  });
	  window.onpageshow = function (e) {
	    if (e.persisted) {
	      window.location.reload();
	    }
	  };
	};
	
	// -------------------------------------------------------------------
	// detectionScroll
	// →
	// -------------------------------------------------------------------
	var detectionScroll = function detectionScroll() {
	  var targetHeader = document.getElementById('header');
	  var targetTotop = document.getElementById('totop');
	  var targetHeight = 120;
	  window.addEventListener('scroll', function () {
	    var scrollVolume = window.pageYOffset;
	    if (scrollVolume > targetHeight) {
	      targetHeader.classList.add('is-Scrolled');
	      targetTotop.classList.add('is-Scrolled');
	    } else {
	      targetHeader.classList.remove('is-Scrolled');
	      targetTotop.classList.remove('is-Scrolled');
	    }
	  }, false);
	};
	
	// -------------------------------------------------------------------
	// switchServices
	// →
	// -------------------------------------------------------------------
	var switchServices = function switchServices() {
	  var targetButton = document.getElementById('servicesSwitchsButton');
	  var targetContent = document.getElementById('headerServicesContent');
	  if (windowWidth > breakPoint) {
	    targetButton.addEventListener('mouseenter', function () {
	      targetButton.classList.remove('is-Close');
	      targetContent.classList.remove('is-Close');
	    }, false);
	    targetButton.addEventListener('mouseleave', function () {
	      targetButton.classList.add('is-Close');
	      targetContent.classList.add('is-Close');
	    }, false);
	    targetContent.addEventListener('mouseenter', function () {
	      targetButton.classList.remove('is-Close');
	      targetContent.classList.remove('is-Close');
	    }, false);
	    targetContent.addEventListener('mouseleave', function () {
	      targetButton.classList.add('is-Close');
	      targetContent.classList.add('is-Close');
	    }, false);
	  }
	};
	
	// -------------------------------------------------------------------
	// switchHeader
	// →
	// -------------------------------------------------------------------
	var switchHeader = function switchHeader() {
	  var targetButton = document.getElementById('headerSwitchButton');
	  var targetContent = document.getElementById('headerSwitchContent');
	  if (windowWidth <= breakPoint) {
	    targetButton.addEventListener('click', function () {
	      if (targetButton.classList.contains('is-Open')) {
	        targetButton.classList.remove('is-Open');
	        targetContent.classList.remove('is-Open');
	      } else {
	        targetButton.classList.add('is-Open');
	        targetContent.classList.add('is-Open');
	      }
	    }, false);
	  }
	};
	
	// -------------------------------------------------------------------
	// tilePost
	// →
	// -------------------------------------------------------------------
	var tilePost = function tilePost() {
	  $(window).on('load resize', function () {
	    $('.st-Post_List_Item_Title').tile();
	  });
	};
	
	// -------------------------------------------------------------------
	// anchorScroll
	// →
	// -------------------------------------------------------------------
	var anchorScroll = function anchorScroll() {
	  var $anchor = $('a[href^=#]');
	  $anchor.click(function () {
	    var speed = 850;
	    var href = $(this).attr('href');
	    var target = $(href == '#' || href == '' ? 'html' : href);
	    var position = target.offset().top;
	    if (windowWidthJQ > breakPoint) {
	      position = target.offset().top - 92;
	    } else {
	      position = target.offset().top - windowWidthJQ * 0.1825;
	    }
	    $('html, body').animate({
	      scrollTop: position
	    }, speed, 'swing');
	    return false;
	  });
	};
	
	exports.loadFonts = loadFonts;
	exports.detectionScroll = detectionScroll;
	exports.switchHeader = switchHeader;
	exports.switchServices = switchServices;
	exports.tilePost = tilePost;
	exports.anchorScroll = anchorScroll;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// services/app.bundle.js